import React, { memo } from "react"
import { makeStyles } from "@material-ui/core"
import moment from "moment-timezone"
import { useDateUtils } from "../../utils"
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  overdue: {
    color: theme.palette.warning.main,
  },
}))

const FormatShortTime = ({ value, showOverdue = false, overdueSuffix = "" }) => {
  const {
    location: { timeZone },
  } = useAuth()
  const { formatShortTime } = useDateUtils()
  const classes = useStyles()
  const isOverdue = showOverdue && value && moment(value).tz(timeZone).isSameOrBefore(moment())

  try {
    return (
      <span className={isOverdue ? classes.overdue : null}>
        {value && formatShortTime(value, timeZone)}
        {isOverdue && overdueSuffix && <> {overdueSuffix}</>}
      </span>
    )
  } catch (ex) {
    return <>Data invalid.</>
  }
}

const FormatShortTimeMemo = memo(FormatShortTime)

export { FormatShortTimeMemo as FormatShortTime }
